export const translations = {
  fr: {
    dir: "ltr",
    nav: {
      products: "Produits",
      about: "À propos",
      contact: "Contact",
      cart: "Panier",
    },
    hero: {
      kicker: "Cordeur depuis 2016 · France → Algérie",
      title_1: "MATÉRIEL HEAD",
      title_2: "LIVRÉ DANS LES",
      title_3: "58 WILAYAS",
      desc: "RamzusS importe le meilleur du tennis HEAD directement de France et vous livre partout en Algérie via Yalidine ou Zr Express. Paiement à la livraison ou virement CCP / RIB.",
      cta_shop: "Voir le catalogue",
      cta_wa: "Commander sur WhatsApp",
    },
    marquee: [
      "CORDEUR DEPUIS 2016",
      "LIVRAISON 58 WILAYAS",
      "100% ORIGINAL HEAD",
      "PAIEMENT À LA LIVRAISON",
      "YALIDINE · ZR EXPRESS",
    ],
    trust: {
      title: "Pourquoi nous choisir",
      items: [
        { t: "Importé de France", d: "Stock renouvelé chaque mois depuis la France" },
        { t: "100% Authentique", d: "Partenariat direct avec distributeurs HEAD" },
        { t: "Livraison 58 Wilayas", d: "Yalidine & Zr Express partout en Algérie" },
        { t: "Paiement sécurisé", d: "À la livraison ou virement CCP / RIB" },
      ],
    },
    products: {
      title: "Catalogue",
      subtitle: "Raquettes, cordages, sacs & chaussures",
      categories: { all: "Tout", racket: "Raquettes", string: "Cordages", bag: "Sacs", shoe: "Chaussures", accessory: "Accessoires" },
      add: "Ajouter au panier",
      sold_out: "Rupture de stock",
      on_order: "Sur commande",
      available: "Disponible",
    },
    upsell: {
      title: "Vous ne trouvez pas ce que vous cherchez ?",
      darija: "ما لقيتش لي تحوس عليه ؟ مشكل",
      desc: "Je peux vous importer n'importe quel article de sport depuis la France via DZ Shopper.",
      cta: "Découvrir DZ Shopper",
    },
    cart: {
      title: "Votre panier",
      empty: "Votre panier est vide",
      subtotal: "Sous-total",
      total_eur: "Total EUR",
      total_dzd: "Total DZD",
      checkout: "Commander",
      qty: "Qté",
    },
    form: {
      title: "Informations de livraison",
      name: "Nom complet",
      phone: "Téléphone",
      wilaya: "Wilaya",
      wilaya_placeholder: "Sélectionner votre wilaya",
      address: "Adresse (rue, n°)",
      delivery: "Transporteur",
      delivery_yalidine: "Yalidine",
      delivery_zr: "Zr Express",
      payment: "Paiement",
      payment_cod: "À la livraison",
      payment_transfer: "Virement RIB / CCP",
      note: "Note (optionnel)",
      submit: "Envoyer la commande via WhatsApp",
      rib_title: "Coordonnées pour virement",
    },
    footer: {
      tagline: "DZ Tennis Shopper · Cordeur depuis 2016",
      rights: "Tous droits réservés",
      contact: "Contact",
    },
    admin: {
      btn: "Admin",
      login_title: "Accès administrateur",
      password: "Mot de passe",
      login: "Se connecter",
      wrong: "Mot de passe incorrect",
      title: "Panneau d'administration",
      tab_products: "Produits",
      tab_settings: "Paramètres",
      add_product: "Ajouter un produit",
      import_url: "Importer depuis URL",
      url_placeholder: "Coller l'URL du produit (HEAD, Tennispro, etc.)",
      scrape: "Importer",
      name: "Nom",
      description: "Description",
      image: "URL Image",
      price: "Prix EUR",
      stock: "Stock",
      category: "Catégorie",
      hidden: "Masqué",
      save: "Enregistrer",
      delete: "Supprimer",
      edit: "Modifier",
      exchange_rate: "Taux de change (1€ = ? DZD)",
      rib_info: "Coordonnées RIB / CCP",
      dz_shopper_url: "URL DZ Shopper",
      update_settings: "Mettre à jour",
      confirm_delete: "Supprimer ce produit ?",
    },
  },
  ar: {
    dir: "rtl",
    nav: {
      products: "المنتجات",
      about: "من نحن",
      contact: "اتصل بنا",
      cart: "السلة",
    },
    hero: {
      kicker: "مرتب أوتار منذ 2016 · فرنسا ← الجزائر",
      title_1: "معدات HEAD",
      title_2: "نوصلك في",
      title_3: "58 ولاية",
      desc: "RamzusS يستورد أحسن معدات التنس HEAD مباشرة من فرنسا ويوصلك في كامل التراب الجزائري عبر ياليدين أو زد آر إكسبرس. الدفع عند الاستلام أو عن طريق CCP / RIB.",
      cta_shop: "استعرض المنتجات",
      cta_wa: "اطلب عبر واتساب",
    },
    marquee: [
      "مرتب أوتار منذ 2016",
      "توصيل 58 ولاية",
      "HEAD أصلي 100%",
      "الدفع عند الاستلام",
      "ياليدين · زد آر إكسبرس",
    ],
    trust: {
      title: "لماذا تختارنا",
      items: [
        { t: "مستورد من فرنسا", d: "مخزون متجدد كل شهر من فرنسا" },
        { t: "أصلي 100%", d: "شراكة مباشرة مع موزعي HEAD" },
        { t: "توصيل 58 ولاية", d: "ياليدين وزد آر إكسبرس في كامل الجزائر" },
        { t: "دفع آمن", d: "عند الاستلام أو تحويل CCP / RIB" },
      ],
    },
    products: {
      title: "المنتجات",
      subtitle: "مضارب، أوتار، حقائب وأحذية",
      categories: { all: "الكل", racket: "مضارب", string: "أوتار", bag: "حقائب", shoe: "أحذية", accessory: "إكسسوارات" },
      add: "أضف إلى السلة",
      sold_out: "نفذ المخزون",
      on_order: "حسب الطلب",
      available: "متوفر",
    },
    upsell: {
      title: "لم تجد ما تبحث عنه ؟",
      darija: "ما لقيتش لي تحوس عليه ؟ ماكاش مشكل",
      desc: "نقدر نستورد لك أي منتج رياضي من فرنسا عبر DZ Shopper.",
      cta: "اكتشف DZ Shopper",
    },
    cart: {
      title: "سلتك",
      empty: "السلة فارغة",
      subtotal: "المجموع الفرعي",
      total_eur: "المجموع باليورو",
      total_dzd: "المجموع بالدينار",
      checkout: "اطلب",
      qty: "الكمية",
    },
    form: {
      title: "معلومات التوصيل",
      name: "الاسم الكامل",
      phone: "الهاتف",
      wilaya: "الولاية",
      wilaya_placeholder: "اختر ولايتك",
      address: "العنوان (الشارع، الرقم)",
      delivery: "شركة التوصيل",
      delivery_yalidine: "ياليدين",
      delivery_zr: "زد آر إكسبرس",
      payment: "طريقة الدفع",
      payment_cod: "عند الاستلام",
      payment_transfer: "تحويل RIB / CCP",
      note: "ملاحظة (اختياري)",
      submit: "إرسال الطلب عبر واتساب",
      rib_title: "معلومات التحويل البنكي",
    },
    footer: {
      tagline: "DZ Tennis Shopper · مرتب أوتار منذ 2016",
      rights: "جميع الحقوق محفوظة",
      contact: "اتصل بنا",
    },
    admin: {
      btn: "الإدارة",
      login_title: "دخول المسؤول",
      password: "كلمة المرور",
      login: "دخول",
      wrong: "كلمة مرور خاطئة",
      title: "لوحة التحكم",
      tab_products: "المنتجات",
      tab_settings: "الإعدادات",
      add_product: "إضافة منتج",
      import_url: "استيراد من رابط",
      url_placeholder: "الصق رابط المنتج (HEAD أو أي موقع)",
      scrape: "استيراد",
      name: "الاسم",
      description: "الوصف",
      image: "رابط الصورة",
      price: "السعر يورو",
      stock: "المخزون",
      category: "الفئة",
      hidden: "مخفي",
      save: "حفظ",
      delete: "حذف",
      edit: "تعديل",
      exchange_rate: "سعر الصرف (1€ = ? دج)",
      rib_info: "معلومات RIB / CCP",
      dz_shopper_url: "رابط DZ Shopper",
      update_settings: "تحديث",
      confirm_delete: "حذف هذا المنتج ؟",
    },
  },
};
